module.exports = __webpack_public_path__ + "img/icon-arrow-right.faa4bb7e.svg";